import axios from 'axios';
import { errorLogger } from '../helpers/errorLogger.js';
import { debugLogger } from '../helpers/debugLogger.js';

function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );
}

export function createAxiosInstance(baseURL) {
  const instance = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  let csrfToken = null; // Variable to store the CSRF token

  // Function to fetch the CSRF token
  async function fetchCsrfToken() {
    if (csrfToken) return csrfToken;

    try {
      const response = await axios.get(Drupal.url(`session/token`));
      csrfToken = response.data;
      return csrfToken;
    } catch (error) {
      errorLogger('Error fetching CSRF token:', error);
      return null;
    }
  }

  // Request interceptor to inject the CSRF token if not present
  instance.interceptors.request.use(async (config) => {
    if (!config.headers['Commerce-Cart-Token']) {
      let cartToken = localStorage.getItem('cartToken');

      if (!cartToken) {
        cartToken = uuidv4();
        localStorage.setItem('cartToken', cartToken);
        debugLogger('Cart token set to ', cartToken);
      }

      config.headers['Commerce-Cart-Token'] = cartToken;
    }

    if (!config.headers['X-CSRF-Token']) {
      const token = await fetchCsrfToken();
      if (token) {
        config.headers['X-CSRF-Token'] = token;
      }
    }
    return config;
  }, (error) => {
    return Promise.reject(error);
  });

  return instance;
}
